<template>
  <div class="calico-icon-card">
    <slot />
  </div>
</template>

<script>

export default {
  name: "CalicoIconCard",
};
</script>

<style scoped lang="scss">
.calico-icon-card {
  @include stack-space($space-small);
  @include inset-space($space-medium);
  width: 100%;
  border-radius: $radius-large;
  border: 1px solid $color-neutral-light;
}
</style>